module.exports = __webpack_public_path__ + "3b2ce234bd2cdfb0c9a7401bccee97f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ServeInformation/Assets/grainserve.png
// module id = 1367
// module chunks = 0